import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import { Box, Skeleton } from "@mui/material"

import OverviewCard, { OVERVIEW_CHART_CARD_MIN_HEIGHT_PX } from "./OverviewCard"
import EvolutionGapCard from "./EvolutionGapCard"

const GAP_CARD_SKELETON_BG = "#f9fafb"

const EvolutionGapCardSkeleton = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      p: 1.5,
      borderRadius: 2,
      backgroundColor: GAP_CARD_SKELETON_BG,
    }}
  >
    <Skeleton variant="rounded" width={40} height={40} />
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Skeleton variant="text" width="72%" height={20} />
      <Skeleton variant="text" width="92%" height={16} sx={{ mt: 0.5 }} />
    </Box>
    <Skeleton variant="text" width={80} height={28} sx={{ flexShrink: 0 }} />
  </Box>
)

const EvolutionGapsPanel = ({ gaps, isLoading, currency }) => {
  const certifiedGap = Math.max(0, Number(gaps?.certifiedInvoicedGap) || 0)
  const invoicedCollectedGap = Math.max(
    0,
    Number(gaps?.invoicedCollectedGap) || 0,
  )

  return (
    <OverviewCard
      title={i18n.t("overview.evolutionGapsTitle")}
      infoText={i18n.t("overview.evolutionGapsTooltip")}
      loading={isLoading}
      sx={{ height: "100%", minHeight: OVERVIEW_CHART_CARD_MIN_HEIGHT_PX }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, flex: 1 }}>
        {isLoading ? (
          <>
            <EvolutionGapCardSkeleton />
            <EvolutionGapCardSkeleton />
          </>
        ) : (
          <>
            <EvolutionGapCard
              iconPreset="evolutionGapCertifiedNotInvoiced"
              title={i18n.t("overview.evolutionGapCertifiedNotInvoicedLabel")}
              helper={i18n.t("overview.evolutionGapCertifiedNotInvoicedHelper")}
              amount={certifiedGap}
              currency={currency}
            />
            <EvolutionGapCard
              iconPreset="evolutionGapInvoicedNotCollected"
              title={i18n.t("overview.evolutionGapInvoicedNotCollectedLabel")}
              helper={i18n.t("overview.evolutionGapInvoicedNotCollectedHelper")}
              amount={invoicedCollectedGap}
              currency={currency}
            />
          </>
        )}
      </Box>
    </OverviewCard>
  )
}

EvolutionGapsPanel.propTypes = {
  gaps: PropTypes.shape({
    certifiedInvoicedGap: PropTypes.number,
    invoicedCollectedGap: PropTypes.number,
  }),
  isLoading: PropTypes.bool,
  currency: PropTypes.string,
}

EvolutionGapsPanel.defaultProps = {
  gaps: undefined,
  isLoading: false,
  currency: "",
}

export default EvolutionGapsPanel
